unit Unit3;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomControl, VCL.TMSFNCCustomPicker, VCL.TMSFNCDatePicker;

type
  TForm3 = class(TForm)
    Convert: TButton;
    DTPicker_StartDate: TTMSFNCDatePicker;
    procedure ConvertClick(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  Form3: TForm3;

implementation

{$R *.dfm}

procedure TForm3.ConvertClick(Sender: TObject);
var
  LocalTimeStamp : string;
  FS: TFormatSettings;
begin
  LocalTimeStamp := '1999-01-01 00:00:00';
  FS := TFormatSettings.Create;
  FS.DateSeparator := '-';
  FS.TimeSeparator := ':';
  FS.ShortDateFormat := 'yyyy-MM-dd';
  FS.LongTimeFormat := 'hh:nn:ss';  // note: 'nn' = minutes
  DTPicker_StartDate.selectedDate := StrToDateTime(LocalTimeStamp, FS);
end;

procedure TForm3.LoadDFMValues;
begin
  inherited LoadDFMValues;

  Convert := TButton.Create(Self);
  DTPicker_StartDate := TTMSFNCDatePicker.Create(Self);

  Convert.BeforeLoadDFMValues;
  DTPicker_StartDate.BeforeLoadDFMValues;
  try
    Name := 'Form3';
    Width := 1269;
    Height := 941;
    Convert.SetParentComponent(Self);
    Convert.Name := 'Convert';
    Convert.Left := 400;
    Convert.Top := 224;
    Convert.Width := 369;
    Convert.Height := 113;
    Convert.Caption := 'Convert';
    Convert.HeightPercent := 100.000000000000000000;
    Convert.WidthPercent := 100.000000000000000000;
    SetEvent(Convert, Self, 'OnClick', 'ConvertClick');
    DTPicker_StartDate.SetParentComponent(Self);
    DTPicker_StartDate.Name := 'DTPicker_StartDate';
    DTPicker_StartDate.AlignWithMargins := True;
    DTPicker_StartDate.Left := 353;
    DTPicker_StartDate.Top := 433;
    DTPicker_StartDate.Width := 576;
    DTPicker_StartDate.Height := 88;
    DTPicker_StartDate.Margins.Top := 9;
    DTPicker_StartDate.Margins.Right := 200;
    DTPicker_StartDate.Margins.Bottom := 2;
    DTPicker_StartDate.ParentDoubleBuffered := False;
    DTPicker_StartDate.DoubleBuffered := True;
    DTPicker_StartDate.Font.Charset := DEFAULT_CHARSET;
    DTPicker_StartDate.Font.Color := clWindowText;
    DTPicker_StartDate.Font.Height := -11;
    DTPicker_StartDate.Font.Name := 'Tahoma';
    DTPicker_StartDate.Font.Style := [];
    DTPicker_StartDate.TabOrder := 1;
    DTPicker_StartDate.AllowNumericNullValue := False;
    DTPicker_StartDate.FirstDay := 1;
    DTPicker_StartDate.BadgeSize := 14;
    DTPicker_StartDate.Header.Font.Charset := DEFAULT_CHARSET;
    DTPicker_StartDate.Header.Font.Color := clWindowText;
    DTPicker_StartDate.Header.Font.Height := -11;
    DTPicker_StartDate.Header.Font.Name := 'Tahoma';
    DTPicker_StartDate.Header.Font.Style := [];
    DTPicker_StartDate.Footer.Fill.Kind := gfkGradient;
    DTPicker_StartDate.Footer.Fill.Color := 16578806;
    DTPicker_StartDate.Footer.Fill.ColorTo := 16380654;
    DTPicker_StartDate.Footer.Font.Charset := DEFAULT_CHARSET;
    DTPicker_StartDate.Footer.Font.Color := 4539717;
    DTPicker_StartDate.Footer.Font.Height := -13;
    DTPicker_StartDate.Footer.Font.Name := 'Tahoma';
    DTPicker_StartDate.Footer.Font.Style := [];
    DTPicker_StartDate.DropDownWidth := 200.000000000000000000;
    DTPicker_StartDate.DropDownHeight := 180.000000000000000000;
    DTPicker_StartDate.SelectedDate := 36151.000000000000000000;
    DTPicker_StartDate.WeekNumberAppearance.Font.Charset := DEFAULT_CHARSET;
    DTPicker_StartDate.WeekNumberAppearance.Font.Color := 8026746;
    DTPicker_StartDate.WeekNumberAppearance.Font.Height := -11;
    DTPicker_StartDate.WeekNumberAppearance.Font.Name := 'Tahoma';
    DTPicker_StartDate.WeekNumberAppearance.Font.Style := [];
    DTPicker_StartDate.DateAppearance.Font.Charset := DEFAULT_CHARSET;
    DTPicker_StartDate.DateAppearance.Font.Color := 8026746;
    DTPicker_StartDate.DateAppearance.Font.Height := -11;
    DTPicker_StartDate.DateAppearance.Font.Name := 'Tahoma';
    DTPicker_StartDate.DateAppearance.Font.Style := [];
    DTPicker_StartDate.DateAppearance.SelectedFill.Color := 16380654;
    DTPicker_StartDate.DateAppearance.SelectedFont.Charset := DEFAULT_CHARSET;
    DTPicker_StartDate.DateAppearance.SelectedFont.Color := 4539717;
    DTPicker_StartDate.DateAppearance.SelectedFont.Height := -13;
    DTPicker_StartDate.DateAppearance.SelectedFont.Name := 'Tahoma';
    DTPicker_StartDate.DateAppearance.SelectedFont.Style := [fsBold];
    DTPicker_StartDate.DateAppearance.SelectedStroke.Color := 15702829;
    DTPicker_StartDate.DateAppearance.DisabledFont.Charset := DEFAULT_CHARSET;
    DTPicker_StartDate.DateAppearance.DisabledFont.Color := clLightgray;
    DTPicker_StartDate.DateAppearance.DisabledFont.Height := -11;
    DTPicker_StartDate.DateAppearance.DisabledFont.Name := 'Tahoma';
    DTPicker_StartDate.DateAppearance.DisabledFont.Style := [];
    DTPicker_StartDate.DateAppearance.DateBeforeFont.Charset := DEFAULT_CHARSET;
    DTPicker_StartDate.DateAppearance.DateBeforeFont.Color := 12303291;
    DTPicker_StartDate.DateAppearance.DateBeforeFont.Height := -11;
    DTPicker_StartDate.DateAppearance.DateBeforeFont.Name := 'Tahoma';
    DTPicker_StartDate.DateAppearance.DateBeforeFont.Style := [];
    DTPicker_StartDate.DateAppearance.DateAfterFont.Charset := DEFAULT_CHARSET;
    DTPicker_StartDate.DateAppearance.DateAfterFont.Color := 12303291;
    DTPicker_StartDate.DateAppearance.DateAfterFont.Height := -11;
    DTPicker_StartDate.DateAppearance.DateAfterFont.Name := 'Tahoma';
    DTPicker_StartDate.DateAppearance.DateAfterFont.Style := [];
    DTPicker_StartDate.DateAppearance.TodayFont.Charset := DEFAULT_CHARSET;
    DTPicker_StartDate.DateAppearance.TodayFont.Color := 15702829;
    DTPicker_StartDate.DateAppearance.TodayFont.Height := -11;
    DTPicker_StartDate.DateAppearance.TodayFont.Name := 'Tahoma';
    DTPicker_StartDate.DateAppearance.TodayFont.Style := [fsBold];
    DTPicker_StartDate.DateAppearance.BadgeFont.Charset := DEFAULT_CHARSET;
    DTPicker_StartDate.DateAppearance.BadgeFont.Color := clWhite;
    DTPicker_StartDate.DateAppearance.BadgeFont.Height := -9;
    DTPicker_StartDate.DateAppearance.BadgeFont.Name := 'Tahoma';
    DTPicker_StartDate.DateAppearance.BadgeFont.Style := [];
    DTPicker_StartDate.DateAppearance.ShowFocus := False;
    DTPicker_StartDate.DayNameAppearance.Font.Charset := DEFAULT_CHARSET;
    DTPicker_StartDate.DayNameAppearance.Font.Color := 8026746;
    DTPicker_StartDate.DayNameAppearance.Font.Height := -11;
    DTPicker_StartDate.DayNameAppearance.Font.Name := 'Tahoma';
    DTPicker_StartDate.DayNameAppearance.Font.Style := [];
    DTPicker_StartDate.LineAppearance.Stroke.Color := clDarkgray;
  finally
    Convert.AfterLoadDFMValues;
    DTPicker_StartDate.AfterLoadDFMValues;
  end;
end;

end.